/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Components.Controls {

    import Utilities = Meevo.Components.Common.Utilities;

    class SimpleDateRangeComponent implements ng.IComponentController {
        contentKey: string;
        from: Date;
        to: Date;
        fromRequired?: boolean;
        toRequired?: boolean;
        fromDefault?: Date;
        toDefault?: Date;
        fromMin?: Date;
        toMin?: Date;

        get fromValue() {
            return this.from;
        }

        set fromValue(value: Date) {
            this.from = moment(value).startOf('day').toDate();

            this.updateToMinValue();
        }

        get toValue() {
            return this.to;
        }

        set toValue(value: Date) {
            this.to = moment(value).endOf('day').toDate();
        }

        $onInit() {
            this.fromRequired = Utilities.defaultIfNothing(this.fromRequired, false);
            this.toRequired = Utilities.defaultIfNothing(this.toRequired, false);

            if (!this.from && this.fromDefault) {
                this.fromValue = this.fromDefault;
            }
            if (!this.to && this.toDefault) {
                this.toValue = this.toDefault;
            }

            this.updateToMinValue();
        }

        updateToMinValue() {
            this.toMin = Utilities.defaultIfNothing(this.toMin || this.fromMin, this.from || new Date());

            if (this.from && this.from > this.toMin) {
                this.toMin = this.from;
            }
        }
    }

    angular.module('meevo.components.controls')
        .component('simpleDateRange', {
            templateUrl: 'app/components/controls/simple-date-range/simple-date-range.component.html',
            bindings: {
                disabled: "=ngDisabled",
                contentKey: '@',
                from: '=',
                to: '=?',
                fromRequired: '=?',
                toRequired: '=?',
                fromDefault: '=?',
                toDefault: '=?',
                fromMin: '=?',
                toMin: '=?',
            },
            controller: SimpleDateRangeComponent
        });
}
